import dayjs from 'dayjs';

const integerFormat = new Intl.NumberFormat('de-DE');
const rateFormat = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

// Integer counter formatting ("1.234"); missing values render as 0.
export const formatNumber = value => integerFormat.format(Math.round(Number(value) || 0));

// Rates arrive as percent numbers (e.g. 42.5) and render as "42,5 %".
export const formatRate = value => `${rateFormat.format(Number(value) || 0)} %`;

// Date-times render as "07.07.2026 14:30"; missing values as an em dash.
export const formatDateTime = value => (value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '—');
